import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class FriendChooseDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.lblTitle = null;

    this.friendContainer = null;
    this.friends = null;

    this.selectedFriend = null;

    this.lblTitle = ABCyaPhaser.Text.addText(0,0, 42,0x006699, FontKeys._bpreplaybold, ABCyaPhaser.Localization.instance.getLocalizedString('select_a_friend'), this, true).setOrigin(0.5);

    this.friendContainer = this.scene.add.container();
    this.friends = [];
    let curX = 0;
    for (let i = 0; i < 3; i++) {
      const item = ABCyaPhaser.Images.addImage(curX,0, `Friend_${i + 1}`,this.friendContainer).setInteractive();
      item.friendID = i + 1;
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.onClickChoice(item));
      this.friends.push(item);
      curX += item.width + 80;
    }
    this.friendContainer.x = this.friends[0].width / 2;
    this.friendContainer.y = 120;
    this.add(this.friendContainer);
    this.lblTitle.x = this.friendContainer.getBounds().width / 2;
  }

  onClickChoice (friend) {
    if (friend === this.selectedFriend) return;
    if (this.selectedFriend) {
      this.selectedFriend.setFrame(`Friend_${this.selectedFriend.friendID}`);
    }
    this.selectedFriend = friend;
    friend.setFrame(`Friend_${this.selectedFriend.friendID}_Outline`);
    this.emit('FRIEND_SELECTED');
  }

  getSelectedFriendID () {
    let fid = -1;
    if (this.selectedFriend) {
      fid = this.selectedFriend.friendID;
    }
    return fid;
  }
}